/* eslint-disable @typescript-eslint/no-explicit-any */
import { PUP_DISPLAY_NAME } from "../config"
import { Trello } from "../types/trello"

export async function getCardBackSection(
  t: Trello.PowerUp.IFrame,
  props: any
): Promise<Trello.PowerUp.CardBackSection> {
  return {
    title: PUP_DISPLAY_NAME,
    icon: props.baseUrl + props.logo.dark,
    content: {
      type: "iframe",
      // The header can run to three rows (customer, contact, totals) before the
      // scrolling time-entry list starts, so keep enough room for a few entries.
      height: 380,
      url: t.signUrl("./card-back-section.html")
    }
  }
}
